import { removeInvalidItems } from '@/services/adapters/transformations/removeInvalidItems'
import { IDataStore } from '@/services/dataStore/IDataStore'
import { retryTimeouts } from '@/services/dataStore/retryTimeouts'
import useDataStore from '@/services/dataStore/useDataStore'
import { ILayerPack, LayerPackSchema } from '@lifk/types'
import useSWRV from 'swrv'
import { z } from 'zod'

const useGetLayerPacks = () => {
  const {
    dataStore,
    dataStoreSWRVKey,
    handleDataStoreError,
    disableValidations
  } = useDataStore()

  async function getLayerPacks(dataStore: IDataStore): Promise<ILayerPack[]> {
    try {
      const response = await retryTimeouts(() => dataStore.getLayerPacks())

      const validation = z.array(LayerPackSchema).safeParse(response)
      let layerPacks: ILayerPack[] = validation.data ?? []
      if (!validation.success) {
        layerPacks = removeInvalidItems(
          response,
          validation.error,
          disableValidations.value
        )
      }

      return layerPacks
    } catch (e) {
      handleDataStoreError(e, 'layerPacks')
      throw e
    }
  }

  const result = useSWRV(
    () => `/layer-packs/${dataStoreSWRVKey.value.perspective}`,
    async () => {
      return await getLayerPacks(dataStore.value)
    },
    {
      // 30s for adapters to prevent too many API calls to paid CMS's
      dedupingInterval: 30000,
      shouldRetryOnError: false
    }
  )
  return result
}

export { useGetLayerPacks }
